import React from "react";

const CalendarControls = ({ 
  calFilter, 
  setCalFilter, 
  view, 
  setView, 
  showViewSelector,
  selectedDate,
  onPrevDay,
  onNextDay,
  onToday,
}) => {
  const monthLabel = selectedDate?.toLocaleString("default", { month: "long" }) || "";
  const yearLabel = selectedDate?.getFullYear() || "";
  return (
    <div className="calendar-controls">
      {/* Left: calendar selector */}
      <div className="calendar-selector">
        <span>View:</span>
        <select 
          value={calFilter} 
          onChange={(e) => setCalFilter(e.target.value)}
          className="calendar-dropdown"
        >
          <option>My Calendar</option>
          <option>My Daily Tasks</option>
          <option>My Quadrants</option>
          <option>My Daily Report</option>
        </select>
      </div>
      
      {/* Middle: inline header centered */}
      <div className="calendar-header-inline">
        <div className="date-display">
          <div className="month-year">{monthLabel} {yearLabel}</div>
          <div className="today-nav">
            <button className="nav-btn" onClick={onPrevDay}>Prev</button>
            <button className="today-btn" onClick={onToday}>Today</button>
            <button className="nav-btn" onClick={onNextDay}>Next</button>
          </div>
        </div>
      </div>

      {/* Right: view selector */}
      {showViewSelector && (
        <div className="view-selector">
          <button 
            className={view === "day" ? "view-btn-calendar active" : "view-btn-calendar"}
            onClick={() => setView("day")}
          >
            Day
          </button>
          <button 
            className={view === "3days" ? "view-btn-calendar active" : "view-btn-calendar"}
            onClick={() => setView("3days")}
          >
            3 days
          </button>
          <button 
            className={view === "week" ? "view-btn-calendar active" : "view-btn-calendar"}
            onClick={() => setView("week")}
          >
            Week
          </button>
        </div>
      )}
    </div>
  );
};

export default CalendarControls;